import React, { useRef, useState } from 'react';
import { Content } from '../../styles/navbar.style';

import Icon_Menu from '../../../../images/Icons/menu.svg';
import Icon_Close from '../../../../images/Icons/at_x.svg';
import { MenuButton } from '../../styles/mobileNavbar.style';
import BrandLogo from '../BrandLogo';
import MobileDropdown from '../MobileDropdown';

const MobileNavbar = (props) => {
    const [isMobileDropdownActive, setIsMobileDropdownActive] = useState(false);
    const menuButtonRef = useRef(null);

    return (
        <>
            <Content>
                <BrandLogo />
                <MenuButton
                    ref={menuButtonRef}
                    onClick={() => setIsMobileDropdownActive(!isMobileDropdownActive)}
                >
                    <img src={isMobileDropdownActive ? Icon_Close : Icon_Menu} alt="menu-icon" />
                </MenuButton>
            </Content>
            {isMobileDropdownActive && (
                <MobileDropdown
                    {...props}
                    menuButtonRef={menuButtonRef}
                    setIsMobileDropdownActive={setIsMobileDropdownActive}
                />
            )}
        </>
    );
};

export default MobileNavbar;
